export enum AdditionalServicesStorage {
    SELECTED_SERVICES = "additionalServices.selected_services",
}
